import React from 'react';
import GeneralRevealPill from '@/components/Editor/Form/fields/GeneralRevealPill';
import { defaultProps, defaultIcons } from './settings';
import { jsx as _jsx } from "react/jsx-runtime";

const WidgetEditFormPointChartFields = _ref => {
  let {
    title,
    pillVariant,
    component,
    onChartSelect
  } = _ref;
  const chartType = component ?? 'Bubble';
  return /*#__PURE__*/_jsx(GeneralRevealPill, {
    title: title ?? 'Point Chart',
    pillVariant: pillVariant,
    leftIcon: defaultIcons[chartType],
    onChartSelect: onChartSelect
  });
};

export default WidgetEditFormPointChartFields;
export { defaultProps };